import { useState } from 'react'
import { IDLE, FOCUS, VALID, VISIBLE } from './constants/status'

const useFieldPage = ({ initialStatus = IDLE }) => {
  const [handlers, setHandlers] = useState({})
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [status, setStatus] = useState(initialStatus)

  const isIdle = status === IDLE
  const isFocus = status === FOCUS
  const isValid = status === VALID
  const isVisible = status === VISIBLE

  const toIdle = () => setStatus(IDLE)
  const toFocus = () => setStatus(FOCUS)
  const toValid = () => setStatus(VALID)
  const toVisible = () => setStatus(VISIBLE)

  const handleSubmit = async ev => {
    ev?.preventDefault?.()

    if (!isValid) {
      return
    }

    try {
      setLoading(true)
      setError(false)
      await handlers?.onSubmit?.(ev)
    } catch (err) {
      setError(true)
      setErrorMessage(err.message)
    } finally {
      setLoading(false)
    }
  }

  const handleBack = async ev => {
    try {
      setLoading(true)
      setError(false)
      await handlers?.onBack?.(ev)
      toIdle()
    } catch (err) {
      setError(true)
      setErrorMessage(err.message)
    } finally {
      setLoading(false)
    }
  }

  return {
    status,
    setStatus,
    isIdle,
    isFocus,
    isValid,
    isVisible,
    toIdle,
    toFocus,
    toValid,
    toVisible,
    loading,
    error,
    errorMessage,
    handleSubmit,
    handleBack,
    setHandlers,
  }
}

export { useFieldPage }
